import { ExceptionType } from '@evidentid/tprm-portal-lib/models/entity-details';

const EXCEPTION_TYPE_LABELS: Record<ExceptionType, string> = {
    [ExceptionType.permanent]: 'Permanent',
    [ExceptionType.untilDate]: 'Until date',
    [ExceptionType.untilCoverageExpiration]: 'Until coverage expiration',
    [ExceptionType.untilCoverageChange]: 'Until coverage change',
};

/**
 * Human-readable label for an exception/override expiration type (the backend `expirationType`).
 * Falls back to the raw token when the value is unknown or missing.
 */
export function getExceptionTypeLabel(type: ExceptionType | null | undefined): string {
    if (!type) {
        return '';
    }
    return EXCEPTION_TYPE_LABELS[type] || type;
}
